
import Vue from "vue";
import { Component } from "vue-property-decorator";
import RevisionsList from "@/components/Reusable/Revisions/RevisionsList.vue";
import { globalStore } from "@/store/store-accessor";
import { VariablesRevision } from "../lib/types";
import { fetchRemoteVariablesRevisions } from "@/oxygen/variables/lib/data";
import RevisionsPanel from "@/components/Settings/RevisionsPanel.vue";

@Component({
  components: {
    RevisionsPanel,
    RevisionsList
  }
})
export default class VariablesHistory extends Vue {
  resourceKey: keyof VariablesRevision = "variables";

  get variables() {
    return globalStore.variables;
  }

  get hasUnsavedChangesPresent() {
    return globalStore.variablesHasUnsavedChangesPresent;
  }

  get fetchRevisionsMethod() {
    return fetchRemoteVariablesRevisions;
  }
}
